<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 分步折线图
	export default {
		name: 'DistributionLineChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			chartData: {
				type: Array,
				required: true,
				default: () => [30, 45, 5, 15, 5]
			},
			xAxisData: {
				type: Array,
				required: true,
				default: () => ['1级', '2级', '3级', '4级', '5级']
			},
			yourPosition: {
				type: Number,
				default: 1 // 默认在第2个位置（索引为1）
			},
			lineColor: {
				type: String,
				default: '#1890ff'
			},
			areaColor: {
				type: String,
				default: 'rgba(24, 144, 255, 0.1)'
			},
			markerColor: {
				type: String,
				default: '#1890ff'
			}
		},
		data() {
			return {}
		},
		computed: {
			chartOptions() {
				return {
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						top: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.xAxisData,
						axisLine: {
							lineStyle: {
								color: '#f8f8f8',
								type: 'solid' // 设置为实线
							}
						},
						axisLabel: {
							color: '#333'
						},
						axisTick: {
							show: false
						},
						boundaryGap: false // 设置为false，让x轴从0点开始显示
					},
					yAxis: {
						type: 'value',
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								color: '#f0f0f0',
								type: 'dashed'
							}
						},
						axisLabel: {
							show: false,
							formatter: '{value}%'
						}
					},
					series: [
						{
							data: this.chartData.map((item, index) => {
								// 为yourPosition位置的数据单独设置label
								if (index === this.yourPosition) {
									return {
										value: item,
										label: {
											position: 'bottom', // 设置为底部显示
											offset: [-5, 10] // 额外的偏移量
										}
									}
								}
								return item // 其他数据保持原样
							}),
							type: 'line',
							smooth: false, // 设置为false，使用直线连接
							symbol: 'circle',
							symbolSize: 0,
							itemStyle: {
								color: this.lineColor
							},
							lineStyle: {
								width: 2,
								color: this.lineColor
							},
							areaStyle: {
								color: this.areaColor
							},
							label: {
								show: true,
								position: 'top',
								offset: [5, -5], // 在top基础上再向下偏移10px
								formatter: '{c}%', // 显示数值
								fontSize: 12,
								color: '#333333'
							},
							markPoint: {
								symbol:
									'path://M512.10828459 1.96074383c-204.84891193 0-370.93658169 166.08883485-370.93658169 370.93774675 0 301.38640953 370.93658169 649.14076558 370.93658169 649.14076561s370.93774677-347.75319097 370.93774677-649.14076559C883.04603136 168.04957867 716.95836046 1.96074383 512.10828459 1.96074383zM512.10828459 558.36678143c-102.46986525 0-185.46829085-83.04383546-185.46829085-185.46829085 0-102.42445538 82.9984256-185.46945593 185.46829085-185.46945592 102.42562049 0 185.46945593 83.04499939 185.46945592 185.46945594C697.57774051 475.32294599 614.53390506 558.36678143 512.10828459 558.36678143z',
								symbolSize: [16, 23], // 第一个值控制宽度，第二个值控制高度
								symbolOffset: [0, -10], // 调整图标位置 [水平偏移, 垂直偏移]
								data: [
									{
										name: '您在这',
										coord: [this.yourPosition, this.chartData[this.yourPosition]],
										value: '您在这',
										itemStyle: {
											color: this.markerColor
										},

										label: {
											color: '#296dba',
											fontSize: 14,
											position: 'right'
										}
									}
								]
							}
						}
					],
					tooltip: {
						trigger: 'axis',
						formatter: '{b}: {c}%'
					}
				}
			}
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
